import script from "./HelpCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpCenter.vue?vue&type=script&setup=true&lang=js"

import "./HelpCenter.vue?vue&type=style&index=0&id=2f86f5ea&scoped=true&lang=css"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f86f5ea"]])

export default __exports__